import React from 'react';
import TableCell from '@mui/material/TableCell';

import { COLUMN_TYPES, DISPLAY_KEY, VALUE_KEY, SELECT_PLACEHOLDER } from './Const';
import DatePickerForm from '../DatePickerForm/DatePickerForm';
import SelectField from '../SelectField/SelectField';
import EditableSelect from '../EditableSelect/EditableSelect';
import InputField from '../InputField/InputField';


const getSelectElement = (propsObj) => {
	return (
		<SelectField
			title={''}
			displayKey={DISPLAY_KEY}
			valueKey={VALUE_KEY}
			data={propsObj.availableColumnValues}
			placeholder={SELECT_PLACEHOLDER}
			defaultValue={propsObj.value ? propsObj.value : ''}
			onChange={(value) => propsObj.onValueChange(value, propsObj.row)}
			disabled={!propsObj.editingEnabled}
		/>
	);
};

const getEditableSelectElement = (propsObj) => {
	let selectedDefaultValue = null;
	let defaultValues = [];
	if (Array.isArray(propsObj.value)) {
		selectedDefaultValue = propsObj.value.find((itemObj) => !!itemObj.isDefault);
	}
	if (Array.isArray(propsObj.availableColumnValues)) {
		selectedDefaultValue = propsObj.availableColumnValues.find((itemObj) => !!itemObj.isDefault);
	}
	if (!!!propsObj.availableColumnValues && Array.isArray(propsObj.value)) {
		defaultValues = propsObj.value;
	} else if (propsObj.availableColumnValues && propsObj.availableColumnValues.length) {
		defaultValues = propsObj.availableColumnValues;
	}
	return (
		<EditableSelect
			addItemLabel="Add an Option"
			placeholder="Add / Select an Option"
			defaultItems={defaultValues}
			selectedDefaultValue={selectedDefaultValue}
			onChange={(value) => propsObj.onValueChange(value, propsObj.row)}
			disabled={!propsObj.editingEnabled}
		/>
	);
};

const getInputElement = (propsObj) => {
	return (
		<InputField
			inputBox="inputFieldCell"
			placeholder={propsObj.placeholder}
			defaultValue={propsObj.value ? propsObj.value : ''}
			onChange={(value) => propsObj.onValueChange(value, propsObj.row)}
			disabled={!propsObj.editingEnabled}
			validationRegex={propsObj.validationRegex}
			validationError={propsObj.validationError}
		/>
	);
};

const getDatePickerElement = (propsObj) => {
	return (
		<DatePickerForm
			value={propsObj.value}
			customClassLayout="no-style"
			customClassDateStyle="no-style"
			classDatePicker="datePicker"
			dateHeader={''}
			onChange={(_, dateString) => propsObj.onValueChange(dateString, propsObj.row)}
		/>
	);
};


export const LookupEditCell = (props) => {
	const renderType = (type) => {
		const propsObj = {
			value: props.value,
			row: props.row,
			availableColumnValues: props.availableColumnValues || props.row.dynamicColOptions,
			onValueChange: props.onValueChange,
			classes: props.classes,
			editingEnabled: props.editingEnabled,
			placeholder: props.placeholder,
			validationRegex: props.column.validationRegex || props.row.validationRegex,
			validationError: props.column.validationError || props.row.validationError,
		};

		switch (type) {
			case COLUMN_TYPES.SELECT:
				return getSelectElement(propsObj);
			case COLUMN_TYPES.EDITABLE_SELECT:
				return getEditableSelectElement(propsObj);
			case COLUMN_TYPES.INPUT:
				return getInputElement(propsObj);
			case COLUMN_TYPES.DATE:
				return getDatePickerElement(propsObj);
			// case COLUMN_TYPES.CHECKBOX:
			// 	return getCheckBoxElement(propsObj);
			default:
				return;
		}
	};

	return <TableCell >{renderType(props.colType)}</TableCell>;
};

